(function () {
  if (customElements.get('style-tiles')) return;

  // Drives the theme's native "Product type" filter (Search & Discovery),
  // the same way color-swatches.js drives the Colour filter. One tile can map
  // to several product types; tapping a tile selects only its types (switching
  // away from any other style), tapping the active tile clears it.
  const FILTER_NAME = 'filter.p.product_type';

  function allTypeInputs() {
    return Array.from(document.querySelectorAll('input[name="' + FILTER_NAME + '"]'));
  }

  function parseTypes(str) {
    return (str || '').split(',').map((s) => s.trim()).filter(Boolean);
  }

  class StyleTiles extends HTMLElement {
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll('[data-style-types]'));
      this.clearBtn = this.querySelector('[data-style-clear]');

      this.buttons.forEach((btn) => {
        btn.addEventListener('click', () => this.select(parseTypes(btn.dataset.styleTypes)));
      });

      if (this.clearBtn) {
        this.clearBtn.addEventListener('click', () => this.apply([]));
      }

      document.addEventListener('change', (event) => {
        if (event.target && event.target.name === FILTER_NAME) this.syncActiveState();
      });
      document.addEventListener('on:facet-filters:updated', () => this.syncActiveState());
      window.addEventListener('popstate', () => setTimeout(() => this.syncActiveState(), 600));

      this.syncActiveState();
    }

    isActive(types) {
      const inputs = allTypeInputs();
      const checked = inputs.filter((i) => i.checked).map((i) => i.value);
      if (!checked.length) return false;
      // Active when every checked type belongs to this tile.
      return checked.every((v) => types.includes(v));
    }

    select(types) {
      if (this.isActive(types)) {
        this.apply([]);
      } else {
        this.apply(types);
      }
    }

    apply(types) {
      const inputs = allTypeInputs();
      if (!inputs.length) return; // Product type filter not enabled / not rendered.

      const wanted = inputs.filter((i) => types.includes(i.value));
      if (types.length && !wanted.length) return; // No matching products under current filters.

      let changed = null;
      inputs.forEach((input) => {
        const shouldCheck = types.includes(input.value);
        if (input.checked !== shouldCheck) {
          input.checked = shouldCheck;
          changed = input;
        }
      });

      if (changed) {
        // facet-filters.js listens for 'input' on the filters and serialises
        // the whole form, so one event applies all checkbox changes at once.
        changed.dispatchEvent(new Event('input', { bubbles: true }));
      }
      this.syncActiveState();
    }

    syncActiveState() {
      let anyActive = false;
      this.buttons.forEach((btn) => {
        const active = this.isActive(parseTypes(btn.dataset.styleTypes));
        if (active) anyActive = true;
        btn.parentElement.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', String(active));
      });
      if (this.clearBtn) this.clearBtn.hidden = !anyActive;
    }
  }

  customElements.define('style-tiles', StyleTiles);
})();
